import { all } from "redux-saga/effects";

//Watchers
import authSaga from "./auth";

export default function* rootSaga() {
  yield all([authSaga()]);
}
